import {Typography} from '@mui/material';
import {DlMuiButton, LoadingSpinner, DlMuiDynamicIcon} from '@wallaby-ui/core';
import {LightTable, useFormatters} from '@wallaby-ui/document';
import React from 'react';

import {ShortcutData} from '../DrpCombinationManagementDialog';

type Props = {
  shortcuts: ShortcutData[];
  isLoading: boolean;
  onEdit: () => void;
};

export const ShortcutsList: React.FC<Props> = ({shortcuts, isLoading, onEdit}) => {
  const {t} = useFormatters();

  return (
    <div style={{flexShrink: 0, marginTop: 24, paddingTop: 16, borderTop: '1px solid var(--dlThemeGray-200)'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
        <Typography variant='labelBold' style={{fontSize: 16}}>
          {t('hospitalization.detail.phRec.combination.list.shortcuts')}
        </Typography>
        <DlMuiButton style={{height: 30, width: 140}} type='chip' title={t('common.edit')} onClick={onEdit} />
      </div>

      {isLoading || shortcuts == null || shortcuts.length === 0 ? (
        <LoadingSpinner isVisible />
      ) : (
        <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
          <LightTable
            data={shortcuts}
            isLoading={isLoading}
            columns={[
              {
                field: 'position',
                width: 100,
                title: t('hospitalization.detail.phRec.combination.shortcut.position'),
                render: (row) => `${row.position}`,
              },
              {
                field: 'icon',
                width: 100,
                title: t('hospitalization.detail.phRec.combination.icon'),
                render: (row) => {
                  const {iconName} = row;
                  return iconName ? (
                    <DlMuiDynamicIcon
                      iconName={iconName}
                      noButtonStyles
                      style={{pointerEvents: 'none', color: 'var(--dlLightIconButtonFill)', justifyContent: 'flex-start'}}
                      svgIconStyle={{width: '40%', height: '40%', color: 'var(--dlLightIconButtonFill)'}}
                      sx={{p: 0, m: 0}}
                    />
                  ) : (
                    <span />
                  );
                },
              },
              {
                field: 'label',
                title: t('hospitalization.detail.phRec.combination.label'),
                minWidth: 150, // PDH-1589: readable floor; below it the table scrolls instead of collapsing the column
                render: (row) => <Typography variant='value'>{t(row.combinationInstanceName || '')}</Typography>,
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};
